import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Paper,
  ButtonBase,
  Chip,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ShareIcon from "@mui/icons-material/Share";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "./api/api";
import { ENDPOINTS } from "./api/endpoints";
import AdminNavbar from "./admin/AdminNav";
import TalentNavbar from "./talent/NavigationTalent";
import MediaSelectionDialog from "./MediaSelectionDialog";
import { useLocationLabels } from "./hooks/useLocationLabels";
import { addSpaceAfterCommas } from "./utils/textUtils";
import { Label } from "./utils/Label";
import ShareMenu from "./utils/ShareMenu";
import EditIcon from "@mui/icons-material/Edit";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import TheatersIcon from "@mui/icons-material/Theaters";
import { Tabs, Tab } from "@mui/material";
import AttachFileOutlinedIcon from "@mui/icons-material/AttachFileOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import MovieCreationOutlinedIcon from "@mui/icons-material/MovieCreationOutlined";
const hasValue = (v) => {
  if (v === null || v === undefined) return false;
  const str = String(v).trim();
  if (
    str === "" ||
    /^0+$/.test(str) ||
    /^0+(\.0+)?$/.test(str)
  ) {
    return false;
  }
  return true;
};
const isImageFile = (path) => {
  if (!path) return false;
  const cleanPath = String(path).trim().split(/[?#]/)[0];
  return /\.(jpe?g|png|gif|bmp|webp|avif)$/i.test(cleanPath);
};

const formatHeight = (inches) => {
  if (!hasValue(inches)) return null;
  const ft = Math.floor(inches / 12);
  const rem = inches % 12;
  return `${ft}′${rem}″`;
};
const Pipe = () => <span style={{ color: "#ccc", margin: "0 4px" }}>|</span>;
function FileLink({ url, label }) {
  if (!url) return null;
  const lower = url.toLowerCase();
  const isImage = /\.(jpe?g|png|gif|bmp|webp)$/i.test(lower);
  const Icon = isImage ? ImageIcon : DescriptionIcon;
  return (
    <ButtonBase
      onClick={() => window.open(url, "_blank", "noopener")}
      sx={{ display: "flex", alignItems: "center", mt: 1.5 }}
    >
      <Icon fontSize="medium" sx={{ mr: 1, color: "common.black" }} />
      <Typography
        variant="body2"
        noWrap
        sx={{ color: "common.black", textDecoration: "none" }}
      >
        {label}
      </Typography>
    </ButtonBase>
  );
}
export default function NoticeDetailPage() {
  const { noticeId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const stubNotice = state?.notice || null;
  const [notice, setNotice] = useState(stubNotice || { roles: [] });
  const [isLoading, setIsLoading] = useState(true);
  const { formatLocations } = useLocationLabels();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [anchorEl, setAnchorEl] = useState(null);
  const [shareUrl, setShareUrl] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");
  const [profileData, setProfileData] = useState(null);
  const [resumeData, setResumeData] = useState([]);
  const [mediaData, setMediaData] = useState([]);
  const [profileErrorDialog, setProfileErrorDialog] = useState(false);
  const [missingItems, setMissingItems] = useState([]);
  const [userCredits, setUserCredits] = useState(0);
  const [activeNoticeTab, setActiveNoticeTab] = useState("overview");
  const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);
  const [isFavorite, setIsFavorite] = useState(stubNotice?.favorite === true);
  const showToast = (msg, sev = "success") => {
    setToastMessage(msg);
    setToastSeverity(sev);
    setToastOpen(true);
  };
  useEffect(() => {
    const id = stubNotice?.noticeId || noticeId;
    if (!id) {
      setIsLoading(false);
      return;
    }
    const load = async () => {
      try {
        const email = localStorage.getItem("email") || "";
        const resN = await api.get(
          ENDPOINTS.getNoticeDetails({
            email: email,
            noticeId: id,
          }),
        );
        const full = resN.data?.data?.[0] ?? {};
        setNotice((prev) => ({
          ...prev,
          ...full,
          roles: full.roles ?? prev.roles ?? [],
        }));
        setIsFavorite(full?.favorite === true);
      } catch (err) {
        console.error(err);
        showToast("Failed to load notice", "error");
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [stubNotice?.noticeId, noticeId]);
  useEffect(() => {
    if (!notice) return;
    const title = notice.projectTitle || notice.title || "Casting Notice";
    document.title = `${title} | Casting Calls`;
    return () => {
      document.title = "Casting Calls";
    };
  }, [notice.projectTitle, notice.title]);
  const openShare = (e) => {
    setAnchorEl(e.currentTarget);
    setShareUrl(`${window.location.origin}/casting-call/${notice.noticeId}`);
  };
  const closeShare = () => setAnchorEl(null);
  const toggleFavorite = async () => {
    try {
      const newState = !isFavorite;
      await api.post(ENDPOINTS.saveTalentFavoriteNotice(), {
        talentId: Number(userId),
        noticeId: notice.noticeId,
        isFavorite: newState,
      });
      setIsFavorite(newState);
      showToast(
        newState ? "Added to favorites" : "Removed from favorites",
        "success",
      );
    } catch (err) {
      console.error("Favorite failed", err);
      showToast("Failed to update favorite", "error");
    }
  };
  const hasDescription =
    notice.noticeDescription && notice.noticeDescription.trim().length > 0;
  const hasShortDesc =
    notice.noticeShortDescription &&
    notice.noticeShortDescription.trim().length > 0;
  const hasFiles =
    notice.scriptsPath ||
    notice.picturesandDocumentsPath ||
    notice.photoReferencesPath;
  const shouldShowBox = hasDescription || hasShortDesc || hasFiles;
  const handleDeleteClick = () => setDeleteDialogOpen(true);
  const handleDeleteCancel = () => setDeleteDialogOpen(false);
  const handleDeleteConfirm = async () => {
    setIsDeleting(true);
    try {
      await api.delete(`/api/NewCastingNotice/DeleteCastingNoticeDetails`, {
        params: { noticeId: notice.noticeId },
      });
      showToast("Notice deleted successfully", "success");
      setDeleteDialogOpen(false);
      setTimeout(() => navigate(-1), 1500);
    } catch (err) {
      console.error(err);
      showToast("Failed to delete notice", "error");
      setIsDeleting(false);
    }
  };
  const fetchProfileBundle = async () => {
    try {
      const [profileRes, resumeRes, mediaRes] = await Promise.all([
        api.get(`/api/TalentProfile/get-talent-profile/${userId}`),
        api.get(`/api/TalentProfile/GetUserResumeTextData/${userId}`),
        api.get(`/api/TalentProfile/GetUserMedia/${userId}`),
      ]);
      const profile = profileRes.data?.data;
      const resume = resumeRes.data || [];
      const media = mediaRes.data || [];
      setProfileData(profile);
      setResumeData(resume);
      setMediaData(media);
      return { profile, resume, media };
    } catch (err) {
      console.error(err);
      showToast("Failed to check profile", "error");
      return null;
    }
  };
  const validateProfile = ({ profile, resume, media }) => {
    const missing = [];
    const hasProfilePhoto = (media || []).some(
      (m) =>
        m.mediaName?.startsWith("http") &&
        m.mediaType?.toUpperCase() === "PROFILE",
    );
    const hasGalleryPhoto = (media || []).some(
      (m) =>
        m.mediaName?.startsWith("http") &&
        m.mediaType?.toUpperCase() === "PROFILE",
    );
    if (!hasProfilePhoto) missing.push("Profile Headshot");
    if (!hasGalleryPhoto) missing.push("Main Photo");
    const normalize = (v) =>
      String(v || "")
        .trim()
        .toLowerCase();
    const bioSection = resume.find(
      (r) =>
        normalize(r.resumeTextHeading) === "bio" && r.resumeTextDetails?.trim(),
    );
    const skillsSection = resume.find(
      (r) =>
        normalize(r.resumeTextHeading) === "special skills" &&
        r.resumeTextDetails?.trim(),
    );
    if (!bioSection) missing.push("Bio");
    if (!skillsSection) missing.push("Special Skills");
    //  MEASUREMENTS (any one)
    const measurementFields = [
      profile?.heightStart,
      profile?.heightEnd,
      profile?.weight,
      profile?.bust,
      profile?.waist,
      profile?.hips,
      profile?.shoe,
      profile?.maleSuit,
      profile?.maleWaist,
    ];
    if (!measurementFields.some(hasValue)) {
      missing.push("Measurements");
    }
    if (!profile?.firstName) missing.push("First Name");
    if (!profile?.lastName) missing.push("Last Name");
    if (!profile?.sex) missing.push("Gender");
    const ageFrom = profile?.ageRangeFrom;
    const ageTo = profile?.ageRangeTo;
    if (!hasValue(ageFrom) || !hasValue(ageTo)) {
      missing.push("Age Range (From & To)");
    }
    return missing;
  };
  const fetchUserActiveStatus = async () => {
    try {
      if (!userId) {
        console.error("User ID not found");
        return null;
      }
      const res = await api.get(
        `/api/NewCastingNotice/user-active-status?userId=${encodeURIComponent(userId)}`
      );
      const isActive = res.data?.isActive;
      return Number(isActive) === 1;
    } catch (err) {
      console.error("Failed to fetch user active status", err);
      showToast("Unable to verify your account status.", "error");
      return null;
    }
  };
  const fetchLatestCredits = async () => {
    try {
      const email = localStorage.getItem("email");
      const res = await api.get("/api/NewCastingNotice/GetClientDetails", {
        params: { email },
      });
      const credits =
        res.data?.data?.userCredits ??
        res.data?.data?.[0]?.userCredits ??
        0;
      setUserCredits(credits);
      return credits;
    } catch (err) {
      console.error("Failed to load user credits", err);
      showToast("Unable to verify your available credits.", "error");
      return null;
    }
  };
  const handleRoleClick = async (role) => {
    if (userRole === "ADMIN") return;
    if (role.isSubmitted === 1) return;
    // Get CURRENT account status from server
    const activeFlag = await fetchUserActiveStatus();
    if (activeFlag === null) return;
    // ACTIVE ACCOUNT → no credit check
    if (activeFlag === true) {
      handleApply(role.roleId, role.rolename);
      return;
    }
    // INACTIVE ACCOUNT → check credits
    const latestCredits = await fetchLatestCredits();
    if (latestCredits === null) return;
    // INACTIVE + NO CREDITS → cannot apply
    if (Number(latestCredits) <= 0) {
      showToast(
        "Your free trial credits have ended. Please go to your MY ACCOUNT page to choose a membership plan to continue submitting to the casting notices.",
        "error"
      );
      return;
    }
    // INACTIVE + CREDITS → can apply
    handleApply(role.roleId, role.rolename);
  };
  /*   const handleApply = async (roleId, roleName) => {
    const bundle = await fetchProfileBundle();
    if (!bundle) return;
    const missing = validateProfile(bundle);
    if (missing.length > 0) {
      setMissingItems(missing);
      setProfileErrorDialog(true);
      return;
    }
    //  PROFILE OK
    setSelectedRoleId(roleId);
    setSelectedRoleName(roleName);
    setDialogOpen(true);
  }; */
  const handleApply = async (roleId, roleName) => {
    try {
      const bundle = await fetchProfileBundle();
      if (!bundle) return;
      const missing = validateProfile(bundle);
      if (missing.length > 0) {
        setMissingItems(missing);
        setProfileErrorDialog(true);
        return;
      }
      setSelectedRoleId(roleId);
      setSelectedRoleName(roleName);
      setDialogOpen(true);
    } catch (err) {
      console.error("Apply failed:", err);
      showToast("Something went wrong while applying", "error");
    }
  };
  const parseIfJSON = (value) => {
    try {
      const parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.join(", ");
      if (typeof parsed === "object" && Object.keys(parsed).length === 0)
        return "";
      return parsed;
    } catch {
      return value;
    }
  };
  if (isLoading)
    return (
      <Box
        sx={{
          height: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={48} />
      </Box>
    );
  const roles = Array.isArray(notice?.roles) ? notice.roles : [];

  // Collect all image references into one carousel.
  const photoReferenceItems = [
    notice.photoReferencesPath &&
    isImageFile(notice.photoReferencesPath) && {
      url: notice.photoReferencesPath,
      label: "Project Photo Reference",
      roleName: null,
    },
    notice.picturesandDocumentsPath &&
    isImageFile(notice.picturesandDocumentsPath) && {
      url: notice.picturesandDocumentsPath,
      label: "Project Material",
      roleName: null,
    },
    ...roles
      .filter(
        (role) =>
          role.photoorScriptPath && isImageFile(role.photoorScriptPath)
      )
      .map((role) => ({
        url: role.photoorScriptPath,
        label: `${role.rolename || "Role"} Reference`,
        roleName: role.rolename || "Role",
      })),
  ].filter(Boolean);

  // Avoid showing the same image more than once.
  const uniquePhotoReferences = [
    ...new Map(
      photoReferenceItems.map((item) => [item.url, item])
    ).values(),
  ];

  // Only the notice-level script is shown as a downloadable project document.
  // Role-level non-image references remain available in their respective role cards.
  const documentReferences = notice.scriptsPath
    ? [{ url: notice.scriptsPath, label: "Script Reference" }]
    : [];

  const uniqueDocumentReferences = [
    ...new Map(
      documentReferences.map((item) => [item.url, item])
    ).values(),
  ];

  const hasProjectMaterials =
    uniquePhotoReferences.length > 0 ||
    uniqueDocumentReferences.length > 0;

  return (
    <div>
      {userRole === "ADMIN" ? <AdminNavbar /> : <TalentNavbar />}
      <Dialog
        open={profileErrorDialog}
        onClose={() => setProfileErrorDialog(false)}
      >
        <DialogTitle>Profile Incomplete</DialogTitle>
        <DialogContent>
          <Typography mb={2} variant="body2">
            <b>Complete Your Profile to Submit</b>
            <br />
            You're almost ready to submit, but some required information is missing from your profile.
          </Typography>
          <ul>
            <Typography variant="body2">
              <b>Click a missing item below to go directly to the page where you can add it:</b>
            </Typography>
            {missingItems.map((item, i) => (
              <li key={i}>
                <Typography
                  color="error"
                  sx={{
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  variant="body2"
                  onClick={() => {
                    const routeMap = {
                      Bio: "/editresume?section=bio",
                      "Special Skills": "/editresume?section=special-skills",
                      Measurements: "/editresume?section=measurements",
                      Gender: "/profile",
                      "Age Range (From & To)": "/profile",
                      "First Name": "/profile",
                      "Last Name": "/profile",
                    };
                    setProfileErrorDialog(false);
                    navigate(routeMap[item] || "/editresume");
                  }}
                >
                  {item}
                </Typography>
              </li>
            ))}
          </ul>
          <Typography
            variant="body2"
            sx={{ mt: 2 }}
          >
            Once you've completed all the missing information, return to this casting notice and submit to the role.
            <br />
            <br />
            <b>We want you to have the best chance of booking this role!</b>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setProfileErrorDialog(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setProfileErrorDialog(false);
              navigate("/editresume");
            }}
          >
            Complete Profile
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ maxWidth: 1440, mx: "auto", px: { xs: 1.5, md: 3 }, py: { xs: 2, md: 3 }, color: "#17233f" }}>
        {/* --- Share Menu --- */}
        <ShareMenu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeShare}
          shareUrl={shareUrl}
          title={notice.title}
          pay={notice.payScale}
          location={notice.locationsText}
          deadline={notice.noticeEndDate}
          onCopySuccess={() => showToast("Link copied!", "success")}
        />
        {/* --- CASTING RIBBON --- */}
        <Paper
          elevation={0}
          sx={{
            position: "relative",
            overflow: "hidden",
            display: "flex",
            bgcolor: "#202020",
            background: "linear-gradient(115deg, #202020 0%, #182633 100%)",
            color: "#fff",
            borderRadius: "8px",
            mb: 2,
          }}
        >
          {notice.rushCall && (
            <Box
              sx={{
                flex: "0 0 46px",
                bgcolor: "#d17c7c",
                color: "#fff",
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 800,
                fontSize: 13,
                letterSpacing: 0.5,
                py: 1.5,
              }}
            >
              RUSH CALL
            </Box>
          )}

          <Box
            sx={{
              display: "flex",
              flex: 1,
              minWidth: 0,
              gap: { xs: 2, md: 3 },
              justifyContent: "space-between",
              flexDirection: { xs: "column", md: "row" },
              p: { xs: 2, md: 2 },
              pl: { xs: 2, md: notice.rushCall ? 2.5 : 3 },
            }}
          >
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography
                component="h1"
                sx={{
                  fontSize: { xs: "1.65rem", md: "2.25rem" },
                  lineHeight: 1.12,
                  fontWeight: 800,
                  letterSpacing: "-0.035em",
                  overflowWrap: "anywhere",
                  mb: 1.1,
                }}
              >
                {notice.projectTitle || notice.title || "Casting Call"}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1,
                  mb: 2,
                }}
              >
                {notice.category?.split(",").map((category, index, arr) => (
                  <React.Fragment key={index}>
                    <Typography
                      sx={{
                        fontSize: { xs: 14, md: 16 },
                        color: "#f3f6fb",
                        lineHeight: 1.45,
                      }}
                    >
                      {category.trim()}
                    </Typography>

                    {index < arr.length - 1 && (
                      <Typography sx={{ color: "#aeb8c5", fontSize: "25px", lineHeight: "10px" }}>
                        •
                      </Typography>
                    )}
                  </React.Fragment>
                ))}
              </Box>

              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1, mb: 2 }}>
                <LocationOnIcon sx={{ color: "#fff", mt: "1px", flexShrink: 0 }} />
                <Typography sx={{ fontSize: { xs: 14, md: 16 }, color: "#f3f6fb", lineHeight: 1.45 }}>
                  <Box component="span" sx={{ color: "#cbd5e1", mr: 0.75 }}>
                    Seeking Talent From:
                  </Box>
                  <span style={{ color: "#90b5fe" }}>{formatLocations(notice.auditionLocations || notice.locationCodes || [])}</span>
                </Typography>
              </Box>


              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, minmax(0, 1fr))",
                    lg: "minmax(0, 0.9fr) minmax(0, 0.85fr) minmax(0, 0.9fr) minmax(240px, 1.8fr)",
                  },
                  rowGap: 2,
                  columnGap: 0,
                  mt: 1.5,
                }}
              >
                {/* Union Status */}
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", pr: 1.5 }}>
                  <TheatersIcon sx={{ fontSize: 30, color: "#fff", flexShrink: 0 }} />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ color: "#cbd5e1", fontSize:"1rem" }}>
                      Union Status
                    </Typography>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: 14,
                        fontWeight: 600,
                        overflowWrap: "anywhere",
                      }}
                    >
                      {addSpaceAfterCommas(notice.unionStatus || notice.union || "N/A")}
                    </Typography>
                  </Box>
                </Box>

                {/* Posted */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                    px: { sm: 1.5 },
                    borderLeft: { sm: "1px solid rgba(203,213,225,0.28)" },
                  }}
                >
                  <CalendarMonthIcon sx={{ fontSize: 29, color: "#fff", flexShrink: 0 }} />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ color: "#cbd5e1", fontSize: "1rem" }}>
                      Posted
                    </Typography>
                    <Typography sx={{ color: "#fff", fontSize: 14, fontWeight: 600 }}>
                      {notice.noticeStartDate
                        ? new Date(notice.noticeStartDate).toLocaleDateString()
                        : "N/A"}
                    </Typography>
                    {notice.noticeUpdatedDate &&
                      notice.noticeStartDate &&
                      notice.noticeUpdatedDate.split("T")[0] >
                      notice.noticeStartDate.split("T")[0] && (
                        <Typography sx={{ color: "#cbd5e1", fontSize: 11 }}>
                          Updated {new Date(notice.noticeUpdatedDate).toLocaleDateString()}
                        </Typography>
                      )}
                  </Box>
                </Box>

                {/* Deadline */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                    px: { sm: 1.5 },
                    borderLeft: { sm: "1px solid rgba(203,213,225,0.28)" },
                  }}
                >
                  <CalendarMonthIcon sx={{ fontSize: 29, color: "#fff", flexShrink: 0 }} />
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ color: "#d17c7c", fontSize: "1rem" }}>
                      Deadline
                    </Typography>
                    <Typography
                      sx={{ color: "#d17c7c", fontSize: 16, fontWeight: 800 }}
                    >
                      {notice.noticeEndDate
                        ? new Date(notice.noticeEndDate).toLocaleDateString()
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>

                {/* Pay - Wider column at the end */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                    px: { sm: 1.5 },
                    borderLeft: { sm: "1px solid rgba(203,213,225,0.28)" },
                    minWidth: 0,
                  }}
                >
                  <AttachMoneyIcon sx={{ fontSize: 32, color: "#fff", flexShrink: 0 }} />
                  <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ color: "#cbd5e1", fontSize: "1rem" }}>
                      Pay
                    </Typography>
                    <Typography
                      sx={{
                        color: "#fff",
                        fontSize: 14,
                        fontWeight: 600,
                        overflowWrap: "anywhere",
                        lineHeight: 1.5,
                      }}
                    >
                      {notice.payScale || notice.pay || "N/A"}
                    </Typography>
                  </Box>
                </Box>
              </Box>

            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "row", md: "column" },
                gap: 1,
                flexShrink: 0,
                alignSelf: { xs: "stretch", md: "flex-start" },
                minWidth: { md: 178 },
              }}
            >
              <Button
                fullWidth
                variant="outlined"
                startIcon={isFavorite ? <BookmarkIcon /> : <BookmarkBorderIcon />}
                onClick={toggleFavorite}
                sx={{
                  minHeight: 46,
                  color: isFavorite ? "rgb(209, 124, 124)" : "#fff",
                  borderColor: isFavorite
                    ? "rgb(209, 124, 124)"
                    : "rgba(255,255,255,0.75)",
                  borderRadius: "7px",
                  textTransform: "none",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  "&:hover": {
                    borderColor: isFavorite
                      ? "rgb(209, 124, 124)"
                      : "#90b5fe",
                    bgcolor: isFavorite
                      ? "rgba(209, 124, 124, 0.10)"
                      : "rgba(144,181,254,0.10)",
                  },
                }}
              >
                {isFavorite ? "Saved Casting" : "Save Casting"}
              </Button>
              <Button
                fullWidth
                variant="outlined"
                startIcon={<ShareIcon />}
                onClick={openShare}
                sx={{
                  minHeight: 46,
                  color: "#fff",
                  borderColor: "rgba(255,255,255,0.75)",
                  borderRadius: "7px",
                  textTransform: "none",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  "&:hover": { borderColor: "#90b5fe", bgcolor: "rgba(144,181,254,0.10)" },
                }}
              >
                Share Casting
              </Button>
              {/* EDIT - ADMIN ONLY */}
              {userRole === "ADMIN" && (
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<EditIcon />}
                  onClick={() =>
                    navigate(`/post-casting-call/${notice.noticeId}`, {
                      state: {
                        casting: notice,
                        noticeId: notice.noticeId,
                      },
                    })
                  }
                  sx={{
                    minHeight: 46,
                    color: "#fff",
                    borderColor: "rgba(255,255,255,0.75)",
                    borderRadius: "7px",
                    textTransform: "none",
                    fontWeight: 700,
                    whiteSpace: "nowrap",
                    "&:hover": { borderColor: "#90b5fe", bgcolor: "rgba(144,181,254,0.10)" },
                  }}
                >
                  Edit Casting
                </Button>
              )}
            </Box>
          </Box>
        </Paper>
        {/* ---------- NOTICE CONTENT + ROLES / MATERIALS GRID ---------- */}
        {/* --- NOTICE CONTENT TABS --- */}
        <Box sx={{ mt: 2 }}>
          <Box
            sx={{
              borderBottom: "1px solid #dfe7f2",
              bgcolor: "transparent",
              mb: 2,
            }}
          >
            <Tabs
              value={activeNoticeTab}
              onChange={(_, nextTab) => setActiveNoticeTab(nextTab)}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="Casting notice sections"
              sx={{
                minHeight: 48,
                "& .MuiTab-root": {
                  minHeight: 48,
                  textTransform: "none",
                  fontWeight: 700,
                  color: "#68758f",
                  fontSize: "0.95rem",
                  px: { xs: 1.5, md: 2.5 },
                },
                "& .Mui-selected": { color: "#246fdb" },
                "& .MuiTabs-indicator": {
                  height: 3,
                  borderRadius: "3px 3px 0 0",
                  backgroundColor: "#246fdb",
                },
              }}
            >
              <Tab
                value="overview"
                iconPosition="start"
                label="Overview"
              />
              <Tab
                value="roles"
                iconPosition="start"
                label={`Roles (${roles.length})`}
              />
              {hasProjectMaterials && (
                <Tab
                  value="materials"
                  iconPosition="start"
                  label="Project Materials"
                />
              )}
            </Tabs>
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "minmax(0, 1fr)",
                lg:
                  activeNoticeTab === "materials" || !hasProjectMaterials
                    ? "minmax(0, 1fr)"
                    : "minmax(0, 1.7fr) minmax(320px, 1fr)",
              },
              gap: { xs: 2, md: 2.5 },
              alignItems: "start",
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              {/* ==================== OVERVIEW ==================== */}
              {activeNoticeTab === "overview" && (
                <Box
                  sx={{
                    bgcolor: "#fff",
                    p: { xs: 1.5, md: 2.25 },
                    border: "1px solid #e5ebf4",
                    borderRadius: "10px",
                    boxShadow: "0 2px 10px rgba(24, 45, 75, 0.04)",
                    color: "#17233f",
                  }}
                >
                  {/* About the Project */}
                  <Typography
                    component="h2"
                    sx={{
                      fontSize: { xs: "1.15rem", md: "1.35rem" },
                      fontWeight: 750,
                      letterSpacing: "-0.4px",
                      color: "#101d3a",
                      mb: 0.75,
                    }}
                  >
                    About the Project
                  </Typography>

                  {/* Main Description */}
                  {notice.noticeDescription &&
                    notice.noticeDescription
                      .split(/\r\n\r\n/)
                      .filter(Boolean)
                      .map((para, i) => (
                        <Typography
                          key={`notice-description-${i}`}
                          component="div"
                          sx={{
                            fontSize: "1rem",
                            lineHeight: 1.5,
                            color: "#000",
                            mb: 0.5,
                            overflowWrap: "anywhere",
                            "& p": { mb: 0.5 },
                          }}
                          dangerouslySetInnerHTML={{ __html: para }}
                        />
                      ))}

                  {/* Project Description */}
                  {notice.projectDescription
                    ?.split(/\r\n\r\n/)
                    .filter(Boolean)
                    .map((para, i) => (
                      <Typography
                        key={`project-description-${i}`}
                        component="div"
                        sx={{
                          fontSize: "1rem",
                          lineHeight: 1.5,
                          color: "#000",
                          mb: 0.5,
                          overflowWrap: "anywhere",
                          "& p": { mb: 0.5 },
                        }}
                        dangerouslySetInnerHTML={{ __html: para }}
                      />
                    ))}

                  {/* Production / Shoot Info */}
                  {(notice.noticeShortDescription ||
                    notice.castingOrShootDatesInfo) && (
                      <Box
                        sx={{
                          mt: 2,
                          mb: 1.75,
                          p: { xs: 1.5, md: 2 },
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 1.5,
                          borderRadius: "8px",
                          background:
                            "linear-gradient(110deg, #edf3fb 0%, #f3f7fc 100%)",
                        }}
                      >
                        <MovieCreationOutlinedIcon
                          sx={{
                            color: "#14213d",
                            fontSize: 36,
                            mt: 0.1,
                            flexShrink: 0,
                          }}
                        />

                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography
                            component="h3"
                            sx={{
                              fontSize: "1rem",
                              fontWeight: 750,
                              color: "#14213d",
                              mb: 0.5,
                            }}
                          >
                            Production / Shoot Info
                          </Typography>

                          <Typography
                            component="div"
                            sx={{
                              fontSize: "1rem",
                              lineHeight: 1.55,
                              color: "#000",
                              overflowWrap: "anywhere",
                              "& p": { my: 0 },
                              "& a": { color: "#0875f5" },
                            }}
                            dangerouslySetInnerHTML={{
                              __html: (
                                notice.castingOrShootDatesInfo ||
                                notice.noticeShortDescription ||
                                ""
                              ).replace(/\r\n|\r|\n/g, "<br/>"),
                            }}
                          />
                        </Box>
                      </Box>
                    )}
                </Box>
              )}

              {/* ==================== ROLES ==================== */}
              {(activeNoticeTab === "roles" ||
                activeNoticeTab === "overview") && (
                  <Box
                    sx={{
                      mt: activeNoticeTab === "overview" ? 1.5 : 0,
                      backgroundColor: "#fff",
                      display: "flex",
                      flexDirection: "column",
                      minWidth: 0,
                    }}
                  >
                    {/* Available Roles Heading */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        px: { xs: 0.5, md: 1.5 },
                        pt: 1,
                        pb: 1,
                      }}
                    >
                      <GroupsOutlinedIcon
                        sx={{ color: "#101d3a", fontSize: 27 }}
                      />

                      <Typography
                        component="h2"
                        sx={{
                          fontSize: { xs: "1.1rem", md: "1.25rem" },
                          fontWeight: 750,
                          color: "#101d3a",
                          letterSpacing: "-0.3px",
                        }}
                      >
                        Available Roles - Click on the role title to submit to that role
                      </Typography>
                    </Box>
 {roles.map((role, index) => (
                      <Box
                        key={role.roleId}
                        sx={{
                          position: "relative",
                          display: "flex",
                          alignItems: "stretch",
                          flexDirection: "row",
                          minWidth: 0,
                          my: 0.4,
                          mx: { xs: 0, md: 1.5 },
                          mb: 0.5,
                          p: { xs: 1.25, md: 1.5 },
                          border: "1px solid #e2eaf5",
                          borderLeft: "4px solid #000",
                          borderRadius: "8px",
                          backgroundColor: "#fff",
                          transition:
                            "border-color 160ms ease, box-shadow 160ms ease",
                          "&:hover": {
                            borderColor: "#a8caff",
                            borderLeftColor: "#000",
                            boxShadow: "0 3px 12px rgba(40, 100, 190, 0.08)",
                          },
                        }}
                      >
                        {/* Applied Status */}
                        {role.isSubmitted === 1 && (
                          <Box
                            sx={{
                              alignSelf: "stretch",
                              minWidth: "24px",
                              mr: 1.5,
                              backgroundColor: "success.main",
                              color: "#fff",
                              writingMode: "vertical-rl",
                              transform: "rotate(180deg)",
                              textOrientation: "mixed",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontWeight: 700,
                              fontSize: "11px",
                              letterSpacing: "1px",
                              borderRadius: "3px",
                              px: 0.5,
                              py: 0.75,
                            }}
                          >
                            APPLIED
                          </Box>
                        )}

                        <Box
                          sx={{
                            flex: "1 1 0",
                            minWidth: 0,
                            width: "auto",
                          }}
                        >
                          {/* Role Name */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                              columnGap: 1.25,
                              rowGap: 0.5,
                              mb: 0.35,
                            }}
                          >
                            <Typography
                              component="span"
                              onClick={() => handleRoleClick(role)}
                              sx={{
                                fontSize: "1.1rem",
                                fontWeight: 750,
                                lineHeight: 1.4,
                                color:
                                  role.isSubmitted === 1 ? "#888" : "#90b5fe",
                                cursor:
                                  userRole !== "ADMIN" &&
                                    role.isSubmitted !== 1
                                    ? "pointer"
                                    : "default",
                                "&:hover": {
                                  color:
                                    userRole !== "ADMIN" &&
                                      role.isSubmitted !== 1
                                      ? "#0875ff"
                                      : undefined,
                                  textDecoration:
                                    userRole !== "ADMIN" &&
                                      role.isSubmitted !== 1
                                      ? "underline"
                                      : "none",
                                },
                              }}
                            >
                              {role.rolename}
                            </Typography>

                            {/* Role Type Badge */}
                            {role.roleType && (
                              <Box
                                component="span"
                                sx={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  px: 1.5,
                                  py: 0.35,
                                  borderRadius: "20px",
                                  backgroundColor: "#e4efff",
                                  color: "#0875ff",
                                  fontSize: "0.8rem",
                                  fontWeight: 600,
                                  lineHeight: 1.4,
                                }}
                              >
                                {role.roleType}
                              </Box>
                            )}
                          </Box>

                          {/* Basic Role Details */}
                          <Typography
                            component="div"
                            sx={{
                              fontSize: "1.1rem",
                              lineHeight: 1.55,
                              color: "#000",
                              overflowWrap: "anywhere",
                              mb: 0.2,
                            }}
                          >
                            {role.sex && (
                              <span>{addSpaceAfterCommas(role.sex)}</span>
                            )}

                            {role.sex && role.ethnicity && (
                              <Pipe />
                            )}

                            {role.ethnicity && (
                              <span>
                                {addSpaceAfterCommas(role.ethnicity)}
                              </span>
                            )}

                            {(hasValue(role.ageStart) ||
                              hasValue(role.ageEnd)) && (
                                <>
                                  {(role.sex || role.ethnicity) && <Pipe />}
                                  <span>
                                    Ages: {role.ageStart || "—"}–{role.ageEnd || "—"}
                                  </span>
                                </>
                              )}

                            {role.roleUnion && (
                              <>
                                {(role.sex ||
                                  role.ethnicity ||
                                  hasValue(role.ageStart) ||
                                  hasValue(role.ageEnd)) && <Pipe />}
                                <span>
                                  {addSpaceAfterCommas(role.roleUnion)}
                                </span>
                              </>
                            )}

                          </Typography>

                          {/* Measurements and Vocal Details */}
                          <Typography
                            component="div"
                            sx={{
                              fontSize: "0.9rem",
                              lineHeight: 1.6,
                              color: "#000",
                              overflowWrap: "anywhere",
                            }}
                          >
                            {role.eyeColor && (
                              <>
                                <Label>Eye Color:</Label>
                                <span>{addSpaceAfterCommas(role.eyeColor)}</span>
                              </>
                            )}

                            {role.hairColor && (
                              <>
                                {role.eyeColor && <Pipe />}
                                <Label>Hair Color:</Label>
                                <span>{addSpaceAfterCommas(role.hairColor)}</span>
                              </>
                            )}

                            {(hasValue(role.heightStart) ||
                              hasValue(role.heightEnd)) && (
                                <>
                                  {(role.eyeColor || role.hairColor) && <Pipe />}
                                  <Label>Height:</Label>
                                  <span>
                                    {formatHeight(role.heightStart)} –{" "}
                                    {formatHeight(role.heightEnd)}
                                  </span>
                                </>
                              )}

                            {(hasValue(role.weightStart) ||
                              hasValue(role.weightEnd)) && (
                                <>
                                  {(role.eyeColor ||
                                    role.hairColor ||
                                    hasValue(role.heightStart) ||
                                    hasValue(role.heightEnd)) && <Pipe />}
                                  <Label>Weight:</Label>
                                  <span>
                                    {role.weightStart}-{role.weightEnd} lbs
                                  </span>
                                </>
                              )}

                            {(hasValue(role.suitOne) ||
                              hasValue(role.suitTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Suit:</Label>
                                  <span>{role.suitOne}-{role.suitTwo}</span>
                                </>
                              )}

                            {hasValue(role.shirt) && (
                              <>
                                <Pipe />
                                <Label>Shirt:</Label>
                                <span>{role.shirt}</span>
                              </>
                            )}

                            {(hasValue(role.neckOne) ||
                              hasValue(role.neckTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Neck:</Label>
                                  <span>
                                    {role.neckOne}-{role.neckTwo}″
                                  </span>
                                </>
                              )}

                            {(hasValue(role.sleeveOne) ||
                              hasValue(role.sleeveTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Sleeve:</Label>
                                  <span>
                                    {role.sleeveOne}-{role.sleeveTwo}″
                                  </span>
                                </>
                              )}

                            {(hasValue(role.waistOne) ||
                              hasValue(role.waistTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Waist:</Label>
                                  <span>
                                    {role.waistOne}-{role.waistTwo}″
                                  </span>
                                </>
                              )}

                            {(hasValue(role.inseamOne) ||
                              hasValue(role.inseamTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Inseam:</Label>
                                  <span>
                                    {role.inseamOne}-{role.inseamTwo}″
                                  </span>
                                </>
                              )}

                            {(hasValue(role.shoeOne) ||
                              hasValue(role.shoeTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Shoe:</Label>
                                  <span>
                                    {role.shoeOne}-{role.shoeTwo}
                                  </span>
                                </>
                              )}

                            {(hasValue(role.dressOne) ||
                              hasValue(role.dressTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Dress:</Label>
                                  <span>
                                    {role.dressOne}-{role.dressTwo}
                                  </span>
                                </>
                              )}

                            {(hasValue(role.bustOne) ||
                              hasValue(role.bustTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Bust:</Label>
                                  <span>
                                    {role.bustOne}-{role.bustTwo}
                                  </span>
                                </>
                              )}

                            {hasValue(role.cup) && (
                              <>
                                <Pipe />
                                <Label>Cup:</Label>
                                <span>{role.cup}</span>
                              </>
                            )}

                            {(hasValue(role.femalWaistOne) ||
                              hasValue(role.femalWaistTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Female Waist:</Label>
                                  <span>
                                    {role.femalWaistOne}-{role.femalWaistTwo}
                                  </span>
                                </>
                              )}

                            {(hasValue(role.hipsOne) ||
                              hasValue(role.hipsTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Hips:</Label>
                                  <span>{role.hipsOne}-{role.hipsTwo}</span>
                                </>
                              )}

                            {(hasValue(role.femaleShoeOne) ||
                              hasValue(role.femaleShoeTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Female Shoe:</Label>
                                  <span>
                                    {role.femaleShoeOne}-{role.femaleShoeTwo}
                                  </span>
                                </>
                              )}

                            {hasValue(role.childSize) && (
                              <>
                                <Pipe />
                                <Label>Child Size:</Label>
                                <span>{role.childSize}</span>
                              </>
                            )}

                            {(hasValue(role.childShoeOne) ||
                              hasValue(role.childShoeTwo)) && (
                                <>
                                  <Pipe />
                                  <Label>Child Shoe:</Label>
                                  <span>
                                    {role.childShoeOne}-{role.childShoeTwo}
                                  </span>
                                </>
                              )}

                            {hasValue(role.otherMeasurements) && (
                              <>
                                <Pipe />
                                <Label>Other:</Label>
                                <span>{role.otherMeasurements}</span>
                              </>
                            )}

                            {role.vocalRange && (
                              <>
                                <Pipe />
                                <Label>Vocal Range:</Label>
                                <span>
                                  {addSpaceAfterCommas(
                                    parseIfJSON(role.vocalRange)
                                  )}
                                </span>
                              </>
                            )}

                            {role.vocalStyle && (
                              <>
                                <Pipe />
                                <Label>Vocal Style:</Label>
                                <span>
                                  {addSpaceAfterCommas(
                                    parseIfJSON(role.vocalStyle)
                                  )}
                                </span>
                              </>
                            )}
                          </Typography>

                          {/* Role Description */}
                          {role.roleDetails && (
                            <Typography
                              component="div"
                              sx={{
                                mt: 0.35,
                                fontSize: "1rem",
                                lineHeight: 1.5,
                                color: "#000",
                                overflowWrap: "anywhere",
                                "& p": { my: 0.35 },
                                whiteSpace: "pre-line",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: role.roleDetails,
                              }}
                            />
                          )}

                          {/* Reel Requirements */}
                          {(role.reelRequired === 1 ||
                            role.audioReelRequired === 1) && (
                              <Typography
                                component="div"
                                sx={{
                                  mt: 0.5,
                                  fontSize: "0.8rem",
                                  lineHeight: 1.5,
                                }}
                              >
                                {role.reelRequired === 1 && (
                                  <Box
                                    component="span"
                                    sx={{ color: "#c45d5d", fontWeight: 600 }}
                                  >
                                    Video Reel Required
                                  </Box>
                                )}

                                {role.reelRequired === 1 &&
                                  role.audioReelRequired === 1 && <Pipe />}

                                {role.audioReelRequired === 1 && (
                                  <Box
                                    component="span"
                                    sx={{ color: "#c45d5d", fontWeight: 600 }}
                                  >
                                    Audio Reel Required
                                  </Box>
                                )}
                              </Typography>
                            )}
                          {/* Payment */}
                          {role.payment && (

                            <>
                              <Typography
                                component="div"
                                sx={{
                                  mt: 0.35,
                                  fontSize: "1rem",
                                  lineHeight: 1.5,
                                  color: "#000",
                                  overflowWrap: "anywhere",
                                  "& p": { my: 0.35 },
                                }}
                              >
                                <Label>Pay:</Label>
                                <Box
                                  component="span"
                                >
                                  {role.payment}
                                </Box>
                              </Typography>
                            </>
                          )}

                        </Box>
                        {/* Role Reference Attachment */}
                        {role.photoorScriptPath && (
                          <Box
                            sx={{
                              display: "flex",
                              flex: "0 0 198px",
                              width: "198px",
                              minWidth: "198px",
                              alignSelf: "stretch",
                              justifyContent: "center",
                              alignItems: "center",
                              ml: 1.5,
                              pl: 1.5,
                              borderLeft: "1px solid #cbd8eb",
                              mt: 0,
                              "& > *": {
                                width: "100%",
                                maxWidth: "100%",
                              },
                            }}
                          >
                           {role.photoorScriptPath && (
  /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(role.photoorScriptPath) ? (
    <img
      src={role.photoorScriptPath}
      alt="Role Reference"
      style={{
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
        borderRadius: "8px",
      }}
    />
  ) : (
    <FileLink
      url={role.photoorScriptPath}
      label="Role Reference"
    />
  )
)}
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>
                )}
            </Box>


            {/* --- PROJECT MATERIALS SIDEBAR --- */}
            {hasProjectMaterials && (
              <Box
                sx={{
                  minWidth: 0,
                  bgcolor: "#fff",
                  p: { xs: 1.5, md: 2 },
                  border: "1px solid #e5ebf4",
                  borderRadius: "10px",
                  boxShadow: "0 2px 10px rgba(24,45,75,0.04)",
                  position: { lg: "sticky" },
                  top: { lg: 16 },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                  <AttachFileOutlinedIcon sx={{ color: "#90b5fe", fontSize: 26 }} />
                  <Typography variant="h5" sx={{ fontWeight: 800, color: "#17233f", fontSize: "1.2rem" }}>
                    Project Materials
                  </Typography>
                </Box>

                {/* Photo Reference Carousel */}
                {uniquePhotoReferences.length > 0 && (() => {
                  const activePhotoIndex = selectedPhotoIndex % uniquePhotoReferences.length;
                  const activePhoto = uniquePhotoReferences[activePhotoIndex];
                  const showPreviousPhoto = () =>
                    setSelectedPhotoIndex((current) =>
                      (current - 1 + uniquePhotoReferences.length) % uniquePhotoReferences.length
                    );
                  const showNextPhoto = () =>
                    setSelectedPhotoIndex((current) =>
                      (current + 1) % uniquePhotoReferences.length
                    );

                  return (
                    <Box sx={{ mb: 2 }}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.75,
                          px: 1,
                          py: 0.5,
                          border: "1px solid #e5ebf4",
                          borderRadius: "8px 8px 0 0",
                          minHeight: 40,
                        }}
                      >
                        <ImageIcon sx={{ color: "#90b5fe", fontSize: 23 }} />
                        <Typography sx={{ fontWeight: 700, color: "#17233f", fontSize: 13 }}>
                          Photo Reference
                        </Typography>
                        <Typography sx={{ color: "#68758f", fontSize: 12 }}>
                          ({uniquePhotoReferences.length} images)
                        </Typography>
                        <Box sx={{ flex: 1 }} />
                        <IconButton
                          size="small"
                          aria-label="Previous photo"
                          onClick={showPreviousPhoto}
                          disabled={uniquePhotoReferences.length < 2}
                          sx={{ p: 0.25, color: "#68758f" }}
                        >
                          <ChevronLeftIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          aria-label="Next photo"
                          onClick={showNextPhoto}
                          disabled={uniquePhotoReferences.length < 2}
                          sx={{ p: 0.25, color: "#68758f" }}
                        >
                          <ChevronRightIcon fontSize="small" />
                        </IconButton>
                      </Box>

                      <Box
                        sx={{
                          border: "1px solid #e5ebf4",
                          borderTop: 0,
                          borderRadius: "0 0 8px 8px",
                          overflow: "hidden",
                          bgcolor: "#f5f7fb",
                        }}
                      >
                        {activePhoto.roleName && (
                          <Box
                            sx={{
                              px: 1.25,
                              py: 0.75,
                              bgcolor: "#fff",
                              borderBottom: "1px solid #e5ebf4",
                            }}
                          >
                            <Typography sx={{ color: "#68758f", fontSize: 12 }}>
                              Role: <Box component="span" sx={{ color: "#17233f", fontWeight: 700 }}>{activePhoto.roleName}</Box>
                            </Typography>
                          </Box>
                        )}
                        <Box
                          component="a"
                          href={activePhoto.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          sx={{ display: "block", lineHeight: 0, bgcolor: "#111" }}
                        >
                          <Box
                            component="img"
                            key={activePhoto.url}
                            src={activePhoto.url}
                            alt={activePhoto.label}
                            loading="lazy"
                            onError={(event) => {
                              console.error(
                                "Project material image failed to load:",
                                event.currentTarget.src
                              );
                              event.currentTarget.style.visibility = "hidden";
                            }}
                            sx={{
                              display: "block",
                              width: "100%",
                              height: 250,
                              objectFit: "contain",
                              bgcolor: "#111",
                            }}
                          />
                        </Box>

                        {uniquePhotoReferences.length > 1 && (
                          <Box
                            sx={{
                              display: "flex",
                              gap: 0.75,
                              p: 0.75,
                              overflowX: "auto",
                              scrollBehavior: "smooth",
                              "&::-webkit-scrollbar": { height: 5 },
                              "&::-webkit-scrollbar-thumb": {
                                backgroundColor: "#cbd5e1",
                                borderRadius: 10,
                              },
                            }}
                          >
                            {uniquePhotoReferences.map((photo, index) => (
                              <ButtonBase
                                key={`${photo.url}-${index}`}
                                onClick={() => setSelectedPhotoIndex(index)}
                                aria-label={`Show photo ${index + 1}`}
                                sx={{
                                  flex: "0 0 74px",
                                  width: 74,
                                  height: 50,
                                  overflow: "hidden",
                                  borderRadius: "5px",
                                  border: index === activePhotoIndex
                                    ? "2px solid #1976d2"
                                    : "1px solid #d8e0ec",
                                  opacity: index === activePhotoIndex ? 1 : 0.82,
                                }}
                              >
                                <Box
                                  component="img"
                                  src={photo.url}
                                  alt={photo.label}
                                  loading="lazy"
                                  sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    display: "block",
                                  }}
                                />
                              </ButtonBase>
                            ))}
                          </Box>
                        )}
                      </Box>
                    </Box>
                  );
                })()}

                {/* Document References */}
                {uniqueDocumentReferences.map((file, index) => (
                  <Box
                    key={`${file.url}-${index}`}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.25,
                      p: 1.25,
                      mb: 1,
                      border: "1px solid #e5ebf4",
                      borderRadius: "8px",
                      "&:hover": {
                        borderColor: "#90b5fe",
                        bgcolor: "#f8faff",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        width: 42,
                        height: 46,
                        flexShrink: 0,
                        display: "grid",
                        placeItems: "center",
                        borderRadius: "6px",
                        bgcolor: "rgba(144,181,254,0.18)",
                        color: "#90b5fe",
                      }}
                    >
                      <DescriptionIcon />
                    </Box>

                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, color: "#17233f" }}>
                        {file.label}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: "#68758f", fontSize: "0.8rem" }}
                      >
                        Project document
                      </Typography>
                    </Box>

                    <IconButton
                      component="a"
                      href={file.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Download ${file.label}`}
                      sx={{ color: "#246fdb" }}
                    >
                      <FileDownloadOutlinedIcon />
                    </IconButton>
                  </Box>
                ))}

              </Box>
            )}
          </Box>
        </Box>

        {/* --- Admin Delete --- */}
        {userRole === "ADMIN" && (
          <>
            <Divider sx={{ my: 3 }} />
            <Box display="flex" justifyContent="center" mt={3} mb={2}>
              <Button
                variant="outlined"
                color="error"
                size="large"
                startIcon={<DeleteOutlineIcon />}
                onClick={handleDeleteClick}
              >
                Delete This Notice
              </Button>
            </Box>
          </>
        )}
        {/* --- Apply Dialog --- */}
        <MediaSelectionDialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          userId={userId}
          notice={notice}
          selectedRoleName={selectedRoleName}
          selectedRoleId={selectedRoleId}
          onSubmitSuccess={(msg) => {
            showToast(msg, "success");
            setNotice((prev) => ({
              ...prev,
              roles: prev.roles.map((r) =>
                r.roleId === selectedRoleId ? { ...r, isSubmitted: 1 } : r,
              ),
            }));
            window.dispatchEvent(new Event("client-details-updated"));
          }}
          onSubmitError={(msg) => showToast(msg, "error")}
        />
        {/* --- Delete Confirm --- */}
        <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete the notice{" "}
              <strong>{notice.title}</strong>?
            </Typography>
            <Typography color="error" mt={2}>
              This action cannot be undone and will permanently remove this
              notice and all associated roles.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCancel} disabled={isDeleting}>
              Cancel
            </Button>
            <Button
              onClick={handleDeleteConfirm}
              color="error"
              variant="contained"
              disabled={isDeleting}
              startIcon={isDeleting ? <CircularProgress size={16} /> : null}
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </Button>
          </DialogActions>
        </Dialog>
        {/* --- Toast --- */}
        <Snackbar
          open={toastOpen}
          autoHideDuration={4000}
          onClose={() => setToastOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setToastOpen(false)}
            severity={toastSeverity}
            variant="filled"
          >
            {toastMessage}
          </Alert>
        </Snackbar>
      </Box>
    </div>
  );
}
